import { getVal } from 'oolib' 
export const parseSpecialConfigSyntax = ({ 
  config, 
  content,
  returnUndefinedIfReplacementWordNotFound = false
}) => {
  let filterConfigString = JSON.stringify(config);

  filterConfigString = parseDynamicValuePaths({ filterConfigString, content });

  //because in the case of 'findQuery' for funneling options (think anno tags lightbox), if a parent tag isnt selected, replacement will fail, and therefore, we must return undefined
  if(filterConfigString === 'replacement-word-not-found' && returnUndefinedIfReplacementWordNotFound){
     return undefined;
  }
  // console.log({returned: JSON.parse(filterConfigString)})
  return JSON.parse(filterConfigString);
};

/**
 * these functions below are mini-services, that perform a single parsing duty
 * we can keep adding new ones that correspond to new syntaxes
 * e.g the current one corresponds to the $valuePath() syntax.
 */

/**
 * capable of processing multiple matches.
 */

/**
 * also, here content === this collection page
 */
const parseDynamicValuePaths = ({ filterConfigString, content }) => {
  let valPathRegex = /\$valuePath\(.*?\)/g; // this questionmark is VERY IMP. i have no idea why tho... need to read up. it has something to do with returning multiple matches. which is what we need.
  let valPathMatch = filterConfigString.match(valPathRegex);

  /**
   * match with the g flag is diff from match without the g flag
   * with g flag it returns an array of all matches including the surrounding
   * words (i.e. $valuePath etc.)
   *
   * matching without gflag returns in the format described below
   */

  if (!valPathMatch) return filterConfigString;
  
  //else
  let toReturn = filterConfigString;
  for (let singleMatch of valPathMatch) {
    // a single match will look something like: $valuePath(_id)
    let actualValPath = singleMatch.replace("$valuePath(", "");
    actualValPath = actualValPath.replace(")", "");

    let replacementWord = getVal(content, actualValPath);
    
    if (replacementWord === undefined) {
      return 'replacement-word-not-found'; // Return original string if any value is undefined
    }
     
     //because if getVal is pointing towards values in an array, then the returned value is an array. imagine something like <tagType>.data._id (where data is actually an array of objects that have _id property)
     if(Array.isArray(replacementWord)){
      // Method 1: Convert array to a properly escaped JSON string
      replacementWord = '\["' + replacementWord.join('", "') + '"\]'
      toReturn = toReturn.replace('"'+singleMatch+'"', replacementWord); //cuz in the case of array we need to replace the quotations also
    }else{
      toReturn = toReturn.replace(singleMatch, replacementWord);
    } 
    
    
  }

  return toReturn;
};
